var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { ErrorLabel } from '../../components/ErrorLabel/ErrorLabel';
import { registerMultilineMaxLength } from '../../utils/registerMaxLength';
export const MultilineInput = (_a) => {
    var _b, _c, _d, _e;
    var { characterLimit = 4000 } = _a, props = __rest(_a, ["characterLimit"]);
    const maxCharactersCount = typeof characterLimit === 'number' ? characterLimit : 4000;
    const noCharacterLimit = !characterLimit;
    const [charactersCount, setCharactersCount] = useState((_c = (_b = props.value) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0);
    const required = props.required ? '*' : '';
    useEffect(() => {
        var _a, _b;
        setCharactersCount((_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
    }, [(_d = props.value) === null || _d === void 0 ? void 0 : _d.length]);
    const errorMessage = (() => {
        if (!noCharacterLimit && charactersCount > maxCharactersCount) {
            return `Maximum length exceed (over ${charactersCount - maxCharactersCount} characters)`;
        }
        else if (props.errorMessage && !props.value && props.required)
            return props.errorMessage;
    })();
    return (_jsxs("div", { children: [_jsx(Controller, { defaultValue: "", name: (_e = props.name) !== null && _e !== void 0 ? _e : '', render: ({ onChange, onBlur, value, name }) => (_jsx(TextField, { name: name, autoFocus: props.autoFocus, onChange: (event) => {
                        onChange(event.target.value);
                        if (props.onChange) {
                            props.onChange(event.target.value);
                        }
                    }, onBlur: onBlur, label: props.label ? `${props.label}${required}` : '', value: value, multiline: true, fullWidth: true, placeholder: props.placeholder, disabled: props.disabled, style: { textTransform: 'capitalize', width: '100%' }, inputProps: {}, size: "small", margin: "dense", helperText: noCharacterLimit ? '' : `${charactersCount}/${maxCharactersCount}`, rows: props.rows })), control: props.control, rules: {
                    required: props.required ? 'This field is required' : '',
                    //something with 'pattern' should match every line, example pattern for isins ISINsPattern = /^[0-9A-Z]+(\n[0-9A-Z]+)*$/;
                    pattern: props.pattern && {
                        value: props.pattern,
                        message: 'Wrong input pattern',
                    },
                    maxLength: noCharacterLimit
                        ? ''
                        : registerMultilineMaxLength(maxCharactersCount, charactersCount)
                            .maxLength,
                } }), _jsx(ErrorLabel, { children: errorMessage })] }));
};
